import React, { useEffect, useState, useMemo } from "react";
import {
    Alert, Chip, CircularProgress, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Box, Button, TablePagination, TextField, InputAdornment,
} from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import SearchIcon from "@mui/icons-material/Search";

import AddIcon from "@mui/icons-material/Add";

import { useGetAdminUserPerfiles } from "../../hooks/AdministracionUsuarios/adminPerfiles/getAdminUserPerfiles";

import AddPerfilUser from "../../components/administracionUsuarios/modalesAdminUser/addPerfilUser";
import UpdateUserPerfil from "../../components/administracionUsuarios/modalesAdminUser/updateUserPerfil";
import DeleteUserPerfil from "../../components/administracionUsuarios/modalesAdminUser/deleteUserPerfil";
import AddPermisoPerfil from "../../components/administracionUsuarios/modalesAdminUser/addPermisoPerfil";
import DeletePermisoPerfil from "../../components/administracionUsuarios/modalesAdminUser/deletePermisoPerfil";

export default function PerfilesView() {

    const {
        perfiles,
        loading,
        error,
        obtenerPerfiles,
    } = useGetAdminUserPerfiles();

    useEffect(() => {
        obtenerPerfiles();
    }, []);

    const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedPerfil, setSelectedPerfil] = useState<any>(null);

    // agregar perfil
    const [openAddPerfil, setOpenAddPerfil] = useState(false);

    // Editar perfil
    const [openUpdatePerfil, setOpenUpdatePerfil] = useState(false);
    const [perfilEditar, setPerfilEditar] = useState<any>(null);


    // Eliminar perfil
    const [openDeletePerfil, setOpenDeletePerfil] = useState(false);
    const [perfilEliminar, setPerfilEliminar] = useState<any>(null);

    const handleOpenAddPerfil = () => {
        setOpenAddPerfil(true);
    };

    const handleCloseAddPerfil = () => {
        setOpenAddPerfil(false);
    };

    const handleOpenUpdatePerfil = (perfil: any) => {
        setPerfilEditar(perfil);
        setOpenUpdatePerfil(true);
    };

    const handleCloseUpdatePerfil = () => {
        setOpenUpdatePerfil(false);
        setPerfilEditar(null);
    };


    const handleOpenDeletePerfil = (perfil: any) => {
        setPerfilEliminar(perfil);
        setOpenDeletePerfil(true);
    };

    const handleCloseDeletePerfil = () => {
        setOpenDeletePerfil(false);
        setPerfilEliminar(null);
    };

    const handlePerfilDeleted = async () => {
        await obtenerPerfiles();
    };

    const handlePerfilUpdated = async () => {
        await obtenerPerfiles();
    };

    const handlePerfilCreated = async () => {
        await obtenerPerfiles();
    };

    // Asignar permisos
    const [openAddPermisoPerfil, setOpenAddPermisoPerfil] = useState(false);
    const [perfilPermisos, setPerfilPermisos] = useState<any>(null);

    const handleOpenAddPermisoPerfil = (perfil: any) => {
        setPerfilPermisos(perfil);
        setOpenAddPermisoPerfil(true);
    };

    const handleCloseAddPermisoPerfil = () => {
        setOpenAddPermisoPerfil(false);
        setPerfilPermisos(null);
    };

    const handlePermisoPerfilCreated = async () => {
        await obtenerPerfiles();
    };

    // Quitar permisos
    const [openDeletePermisoPerfil, setOpenDeletePermisoPerfil] = useState(false);
    const [perfilDeletePermisos, setPerfilDeletePermisos] = useState<any>(null);

    const handleOpenDeletePermisoPerfil = (perfil: any) => {
        setPerfilDeletePermisos(perfil);
        setOpenDeletePermisoPerfil(true);
    };

    const handleCloseDeletePermisoPerfil = () => {
        setOpenDeletePermisoPerfil(false);
        setPerfilDeletePermisos(null);
    };

    const handlePermisoPerfilDeleted = async () => {
        await obtenerPerfiles();
    };


    // Buscador
    const [busqueda, setBusqueda] = useState("");

    // Paginación
    const [page, setPage] = useState(0);
    const rowsPerPage = 10;

    const handleChangePage = (
        event: unknown,
        newPage: number
    ) => {
        setPage(newPage);
    };

    const perfilesFiltrados = useMemo(() => {

        const texto = busqueda.trim().toUpperCase();

        if (!texto) {
            return perfiles;
        }

        return perfiles.filter((perfil) =>
            perfil.nombre.toUpperCase().includes(texto)
        );

    }, [perfiles, busqueda]);


    useEffect(() => {
        setPage(0);
    }, [busqueda]);

    const handleOpenMenu = (
        event: React.MouseEvent<HTMLElement>,
        perfil: any
    ) => {
        setMenuAnchorEl(event.currentTarget);
        setSelectedPerfil(perfil);
    };

    const handleCloseMenu = () => {
        setMenuAnchorEl(null);
        setSelectedPerfil(null);
    };

    const handleEditar = () => {
        handleOpenUpdatePerfil(selectedPerfil);
        handleCloseMenu();
    };

    const handleEliminar = () => {
        handleOpenDeletePerfil(selectedPerfil);
        handleCloseMenu();
    };

    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return (
            <Alert severity="error">
                {error}
            </Alert>
        );
    }

    return (

        <Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
            >

                <TextField
                    size="small"
                    placeholder="Buscar por nombre..."
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                    sx={{ width: 320 }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                />

                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleOpenAddPerfil}
                    sx={{
                        bgcolor: "#1976d2",
                        color: "#fff",
                        textTransform: "none",
                        fontWeight: 600,
                        borderRadius: 2,
                        "&:hover": {
                            bgcolor: "#1565c0",
                        },
                    }}
                >
                    Agregar Perfil
                </Button>

            </Box>

            <TableContainer component={Paper}>

                <Table>

                    <TableHead>

                        <TableRow>

                            <TableCell>Nombre</TableCell>

                            <TableCell>Descripción</TableCell>

                            <TableCell>Estatus</TableCell>

                            <TableCell align="center">
                                Acciones
                            </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {perfilesFiltrados
                            .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                            )
                            .map((perfil) => (

                                <TableRow key={perfil.id}>

                                    <TableCell>
                                        {perfil.nombre}
                                    </TableCell>

                                    <TableCell>
                                        {perfil.descripcion}
                                    </TableCell>

                                    <TableCell>

                                        <Chip
                                            label={
                                                Number(perfil.estatus) === 1
                                                    ? "Activo"
                                                    : "Inactivo"
                                            }
                                            color={
                                                Number(perfil.estatus) === 1
                                                    ? "success"
                                                    : "error"
                                            }
                                            size="small"
                                            sx={{
                                                minWidth: 80,
                                                fontWeight: 600,
                                            }}
                                        />

                                    </TableCell>

                                    <TableCell align="center">

                                        <IconButton
                                            size="small"
                                            onClick={(event) =>
                                                handleOpenMenu(event, perfil)
                                            }
                                        >
                                            <MoreVertIcon />
                                        </IconButton>

                                    </TableCell>

                                </TableRow>

                            ))}
                        {perfilesFiltrados.length === 0 && (

                            <TableRow>

                                <TableCell
                                    colSpan={5}
                                    align="center"
                                >
                                    No se encontraron perfiles.
                                </TableCell>

                            </TableRow>

                        )}
                    </TableBody>

                </Table>

                <TablePagination
                    component="div"
                    count={perfilesFiltrados.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[10]}
                    labelRowsPerPage="Registros por página:"
                    labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} de ${count}`
                    }
                />
                <Menu
                    anchorEl={menuAnchorEl}
                    open={Boolean(menuAnchorEl)}
                    onClose={handleCloseMenu}
                >

                    <MenuItem onClick={handleEditar}>

                        <ListItemIcon>
                            <EditIcon fontSize="small" />
                        </ListItemIcon>

                        <ListItemText>
                            Editar
                        </ListItemText>

                    </MenuItem>

                    <MenuItem
                        onClick={() => {
                            handleOpenAddPermisoPerfil(selectedPerfil);
                            handleCloseMenu();
                        }}
                    >
                        <ListItemIcon>
                            <AddIcon fontSize="small" />
                        </ListItemIcon>

                        <ListItemText>
                            Agregar permisos
                        </ListItemText>

                    </MenuItem>

                    <MenuItem
                        onClick={() => {
                            handleOpenDeletePermisoPerfil(selectedPerfil);
                            handleCloseMenu();
                        }}
                    >

                        <ListItemIcon>

                            <DeleteIcon
                                fontSize="small"
                                color="warning"
                            />

                        </ListItemIcon>

                        <ListItemText>
                            Quitar permisos
                        </ListItemText>

                    </MenuItem>

                    <MenuItem
                        sx={{ color: "error.main" }}
                        onClick={handleEliminar}
                    >

                        <ListItemIcon>
                            <DeleteIcon
                                color="error"
                                fontSize="small"
                            />
                        </ListItemIcon>

                        <ListItemText
                            primary="Eliminar"
                            primaryTypographyProps={{
                                color: "error",
                            }}
                        />

                    </MenuItem>

                </Menu>

            </TableContainer>

            {/*Modales*/}
            <AddPerfilUser
                open={openAddPerfil}
                onClose={handleCloseAddPerfil}
                onSuccess={handlePerfilCreated}
            />

            <UpdateUserPerfil
                open={openUpdatePerfil}
                onClose={handleCloseUpdatePerfil}
                onSuccess={handlePerfilUpdated}
                perfil={perfilEditar}
            />

            <DeleteUserPerfil
                open={openDeletePerfil}
                onClose={handleCloseDeletePerfil}
                onSuccess={handlePerfilDeleted}
                perfil={perfilEliminar}
            />

            <AddPermisoPerfil
                open={openAddPermisoPerfil}
                onClose={handleCloseAddPermisoPerfil}
                onSuccess={handlePermisoPerfilCreated}
                perfil={perfilPermisos}
            />

            <DeletePermisoPerfil
                open={openDeletePermisoPerfil}
                onClose={handleCloseDeletePermisoPerfil}
                onSuccess={handlePermisoPerfilDeleted}
                perfil={perfilDeletePermisos}
            />
        </Box>

    );
}